import React, { useEffect, useState } from "react";
import {
  getFileAttachment,
  saveFileAttachment,
  deleteFileAttachment,
  getFileAttachmentDetails,
} from "../../services/userServices";
import { useTranslation } from "react-i18next";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import classes from "./FileAttachment.module.css";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import BackdropComponent from "components/Spinner/Spinner";
import { SnackBarStoreAction } from "Store/SnackBar";
import { useDispatch } from "react-redux";
import applicationUsageLog from "../../utils/applicationUsagesLog";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import {
  Box,
  Grid,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import ExcelJS from "exceljs";

const btnAttachFile = createTheme({
  palette: {
    btnAttach: {
      main: "#455A64",
      light: "#546E7A",
      dark: "#37474F",
      contrastText: "#FFFFFF",
    },
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FileAttachmentDrawer = (props) => {
  const { t } = useTranslation(["AttachmentDrawer"]);
  const [loading, setLoading] = useState(false);
  const [fileAttachmentType, setFileAttachmentType] = useState([]);
  const [filteredAttachedFiles, setFilteredAttachedFiles] = useState([]);
  const [selectedAttachmentType, setSelectedAttachmentType] = useState(0);
  const [selectedFile, setSelectedFile] = useState([]);
  const [fileAttachError, setFileAttachError] = useState(false);
  const dispatch = useDispatch();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogAction, setDialogAction] = useState(null);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogBulletList, setDialogBulletList] = useState([]);
  const [productionScheduleDetails, setProductionScheduleDetails] = useState(
    [],
  );
  const [isConfirmationDialog, setIsConfirmationDialog] = useState(true);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [openDailog, setOpenDailog] = useState(false);

  const handleDialogOpen = (
    action,
    title,
    message,
    dialogBulletList,
    isConfirmation,
  ) => {
    setDialogAction(() => action);
    setDialogTitle(title || "Confirmation");
    setDialogMessage(message || "Are you sure you want to proceed?");
    setDialogBulletList(dialogBulletList || []);
    setIsConfirmationDialog(isConfirmation || false);
    setDialogOpen(true);
  };

  const handleDialogClose = (confirm) => {
    setDialogOpen(false);
    if (confirm && dialogAction) {
      dialogAction();
    }
  };

  const setFileTypeHandler = (event) => {
    const selectedType = event.target.value;
    setSelectedAttachmentType(selectedType);
  };

  useEffect(() => {
    setFilteredAttachedFiles(
      selectedAttachmentType === "0" || selectedAttachmentType === 0
        ? attachedFiles
        : attachedFiles.filter(
            (file) =>
              file.fileAttachmentTypeId === parseInt(selectedAttachmentType),
          ),
    );
    setSelectedFile([]);
  }, [selectedAttachmentType]);

  const fileUploadHandler = (event) => {
    if (event.target.files.length > 0) {
      setFileAttachError(false);
      const newFiles = Array.from(event.target.files);

      const hasDuplicates = newFiles.some((newFile) =>
        attachedFiles.some(
          (existingFile) => existingFile.fileName === newFile.name,
        ),
      );

      if (hasDuplicates) {
        Snackhandler(true, "Duplicate file(s) found.", "error");
      } else if (newFiles.length > 0) {
        if (selectedAttachmentType === 6) {
          const isValid = validateFileContent(
            newFiles[0],
            selectedAttachmentType,
          );
          if (isValid) {
            setSelectedFile(newFiles);
          }
        } else {
          setSelectedFile(newFiles);
        }
      } else {
        setSelectedFile([]);
      }

      event.currentTarget.value = null;
    }
  };

  const handleUploadClick = async () => {
    if (selectedAttachmentType === 6 && selectedFile.length > 0) {
      const isDuplicate = attachedFiles.find(
        (file) => file.fileAttachmentTypeId === selectedAttachmentType,
      );
      if (!isDuplicate || isDuplicate.totalUsage > 0) {
        const uploadSuccess = await performFileUpload();
        if (uploadSuccess) {
          setAttachedFiles([...attachedFiles, ...selectedFile]);
        }
      } else {
        setOpenDailog(true);
      }
    } else {
      await uploadFile();
    }
  };

  const handleAppend = async () => {
    try {
      setAttachedFiles([...attachedFiles, ...selectedFile]);
      setOpenDailog(false);
      await performFileUpload("append");
    } catch (error) {
      Snackhandler(
        true,
        `Error ocurred while Appending File : ${error}`,
        "error",
      );
    }
  };

  const handleReplace = async () => {
    try {
      setLoading(true);
      const exsistingFile = attachedFiles.find(
        (file) => file.fileAttachmentTypeId === selectedAttachmentType,
      );
      if (exsistingFile) {
        const deleteFile = await deleteFileAttachment(
          exsistingFile.fileDocLibID,
          localStorage.getItem("User"),
        );
        if (deleteFile.status === true) {
          setAttachedFiles((prevFiles) =>
            prevFiles.filter(
              (item) => item.fileDocLibID !== exsistingFile.fileDocLibID,
            ),
          );
          setFilteredAttachedFiles((prevFiles) =>
            prevFiles.filter(
              (item) => item.fileDocLibID !== exsistingFile.fileDocLibID,
            ),
          );
          const uploadSuccess = await performFileUpload("replace");
          if (uploadSuccess) {
            setAttachedFiles(selectedFile);
            setOpenDailog(false);
          }
        }
        setLoading(false);
      }
    } catch (error) {
      Snackhandler(true, "error while replacing the file..", error);
    } finally {
      setLoading(false);
    }
  };

  const removeSelectedFile = (event, item) => {
    if (item) {
      let filterSelectedFile = selectedFile.filter(
        (file) => file.name !== item.name,
      );
      setSelectedFile(filterSelectedFile || []);
      if (
        selectedAttachmentType === 6 &&
        productionScheduleDetails.length > 0
      ) {
        setProductionScheduleDetails([]);
      }
    }
  };

  const validateFileContent = (file, fileAttachmentTypeId) => {
    const allowedFileTypes = [".xlsx", ".xls"];
    const fileType = file.name.slice(-5).toLowerCase();

    if (!allowedFileTypes.includes(fileType)) {
      Snackhandler(true, "Please select a .xlsx, or .xls file.", "error");
      setSelectedFile([]);
      return false;
    }

    const reader = new FileReader();

    // Helper function to validate headers
    const validateHeaders = (fileHeaders, expectedHeaders) => {
      return expectedHeaders.every((header) => fileHeaders.includes(header));
    };

    // Helper function to get column indices
    const getColumnIndices = (fileHeaders) => {
      return {
        shiftTimingsIndex: fileHeaders.indexOf("Start Timings") + 1,
        daysWorkedIndex: fileHeaders.indexOf("Days Worked") + 1,
        shiftSpanIndex: fileHeaders.indexOf("Shift Span") + 1,
      };
    };

    // Helper function to validate required field
    const validateRequiredField = (
      value,
      rowIndex,
      columnIndex,
      Snackhandler,
      setSelectedFile,
    ) => {
      if (!value) {
        Snackhandler(
          true,
          `Invalid or missing data in row ${
            rowIndex + 2
          }, columns ${columnIndex}.`,
          "error",
        );
        setSelectedFile([]);
        return false;
      }
      return true;
    };

    // Helper function to validate shift timings format
    const validateShiftTimings = (
      value,
      rowIndex,
      Snackhandler,
      setSelectedFile,
    ) => {
      const shiftTimingsRegex =
        /^([1-9]|1[0-2]):([0-5]\d)\s?([APap][Mm])\s?-\s?([1-9]|1[0-2]):([0-5]\d)\s?([APap][Mm])$/;

      if (!shiftTimingsRegex.test(value)) {
        Snackhandler(
          true,
          `Invalid 'Start Timings' format in row ${rowIndex + 2}.`,
          "error",
        );
        setSelectedFile([]);
        return false;
      }
      return true;
    };

    // Helper function to validate shift span format
    const validateShiftSpan = (
      value,
      rowIndex,
      Snackhandler,
      setSelectedFile,
    ) => {
      const decimalRegex = /^\d+(\.\d+)?$/;

      if (!decimalRegex.test(value)) {
        Snackhandler(
          true,
          `Invalid 'Shift Span' format in row ${rowIndex + 2}.`,
          "error",
        );
        setSelectedFile([]);
        return false;
      }
      return true;
    };

    // Helper function to validate a single row
    const validateRow = (
      row,
      rowIndex,
      indices,
      Snackhandler,
      setSelectedFile,
    ) => {
      const { shiftTimingsIndex, daysWorkedIndex, shiftSpanIndex } = indices;

      const shiftTimingsValue = row[shiftTimingsIndex];
      const daysWorkedValue = row[daysWorkedIndex];
      const shiftSpanValue = row[shiftSpanIndex];

      // Validate required fields
      if (
        !validateRequiredField(
          shiftTimingsValue,
          rowIndex,
          shiftTimingsIndex,
          Snackhandler,
          setSelectedFile,
        )
      ) {
        return null;
      }

      if (
        !validateRequiredField(
          daysWorkedValue,
          rowIndex,
          daysWorkedIndex,
          Snackhandler,
          setSelectedFile,
        )
      ) {
        return null;
      }

      if (
        !validateRequiredField(
          shiftSpanValue,
          rowIndex,
          shiftSpanIndex,
          Snackhandler,
          setSelectedFile,
        )
      ) {
        return null;
      }

      // Validate formats
      if (
        !validateShiftTimings(
          shiftTimingsValue,
          rowIndex,
          Snackhandler,
          setSelectedFile,
        )
      ) {
        return null;
      }

      if (
        !validateShiftSpan(
          shiftSpanValue,
          rowIndex,
          Snackhandler,
          setSelectedFile,
        )
      ) {
        return null;
      }

      return {
        shiftTimings: shiftTimingsValue,
        dayWorked: daysWorkedValue,
        shiftSpan: shiftSpanValue,
      };
    };

    // Helper function to process all rows
    const processRows = (allRows, indices, Snackhandler, setSelectedFile) => {
      const productionSchedule = [];

      for (let i = 0; i < allRows.length; i++) {
        const row = allRows[i];
        const validatedRow = validateRow(
          row,
          i,
          indices,
          Snackhandler,
          setSelectedFile,
        );

        if (validatedRow === null) {
          return null; // Validation failed
        }

        productionSchedule.push(validatedRow);
      }

      return productionSchedule;
    };

    // Helper function to extract headers from worksheet
    const extractHeaders = (worksheet) => {
      return worksheet
        .getRow(1)
        .values.filter((value) => value !== null && value !== undefined);
    };

    // Helper function to extract data rows from worksheet
    const extractDataRows = (worksheet) => {
      if (worksheet.rowCount <= 1) {
        return [];
      }

      return worksheet
        .getRows(2, worksheet.rowCount - 1)
        .map((row) => row.values);
    };

    // Refactored main function
    reader.onload = async (event) => {
      const content = event.target.result;
      const expectedHeaders = ["Start Timings", "Days Worked", "Shift Span"];

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(content);
      const worksheet = workbook.worksheets[0];

      if (!worksheet) {
        Snackhandler(true, "No worksheet found in Excel file.", "error");
        setSelectedFile([]);
        return false;
      }

      const fileHeaders = extractHeaders(worksheet);

      if (!validateHeaders(fileHeaders, expectedHeaders)) {
        Snackhandler(true, "Invalid column headers.", "error");
        setSelectedFile([]);
        return false;
      }

      const allRows = extractDataRows(worksheet);

      if (allRows.length === 0) {
        Snackhandler(true, "No data rows found in Excel file.", "error");
        setSelectedFile([]);
        return false;
      }

      const indices = getColumnIndices(fileHeaders);
      const productionSchedule = processRows(
        allRows,
        indices,
        Snackhandler,
        setSelectedFile,
      );

      if (productionSchedule === null) {
        return false; // Validation failed
      }

      setProductionScheduleDetails(productionSchedule);
    };

    reader.onerror = () => {
      Snackhandler(true, "Error reading file.", "error");
      setSelectedFile([]);
      return false;
    };

    reader.readAsArrayBuffer(file);
    return true;
  };

  const uploadFile = async () => {
    try {
      if (selectedFile.length === 0) {
        setFileAttachError(true);
      } else {
        setFileAttachError(false);
        await performFileUpload();
      }
    } catch (error) {
      Snackhandler(true, `Error fetching data: ${error}`, "error");
    } finally {
      setLoading(false);
    }
  };

  async function performFileUpload(actionType) {
    try {
      setLoading(true);
      const savedFile = await saveFileAttachment(
        props.data.classRequestId,
        props.data.classRosterId ? props.data.classRosterId : 0,
        selectedAttachmentType,
        localStorage.getItem("User"),
        selectedFile,
        selectedAttachmentType === 6 ? productionScheduleDetails : null,
      );

      if (savedFile.message === "Success") {
        let successMessage = "";
        switch (actionType) {
          case "append":
            successMessage = "File appended successfully..";
            break;
          case "replace":
            successMessage = "File replaced successfully..";
            break;
          default:
            successMessage =
              selectedAttachmentType === 6
                ? `Successfully uploaded File Attachment and Production Schedule (Total records: ${productionScheduleDetails.length}).`
                : "Successfully uploaded File Attachment.";
        }
        setLoading(false);
        Snackhandler(true, successMessage, "success");
      } else {
        Snackhandler(
          true,
          "Failed to upload requested Roster Attachment.",
          "error",
        );
      }
      props.onClose("right", false);
    } catch (error) {
      Snackhandler(true, `Error fetching data: ${error}`, "error");
    } finally {
      setLoading(false);
    }
  }

  const Snackhandler = (open, message, severity) => {
    const obj = {
      open: open,
      message: message,
      severity: severity,
    };

    dispatch(SnackBarStoreAction.updateSnack(obj));
  };

  const handleDownload = () => {
    const filePath =
      process.env.PUBLIC_URL + "/assets/files/ProductionScheduleTemplate.xlsx";

    const link = document.createElement("a");
    link.href = filePath;
    link.setAttribute("download", "SampleProductionSchedule.xlsx");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Helper function to get unique ID based on type
  const getUniqueId = (type, data) => {
    return type === "Classrequest" ? data.classRequestId : data.classRosterId;
  };

  // Helper function to handle file attachment details
  const handleFileAttachmentDetails = async (
    uniqueId,
    type,
    setAttachedFiles,
    setFilteredAttachedFiles,
    setSelectedFile,
    Snackhandler,
  ) => {
    const fileAttachmentDetails = await getFileAttachmentDetails(
      uniqueId,
      type,
    );

    if (fileAttachmentDetails.status) {
      const fileAttachedDetails = fileAttachmentDetails?.data || [];
      setAttachedFiles(fileAttachedDetails);
      setFilteredAttachedFiles(fileAttachedDetails);
      setSelectedFile([]);

      applicationUsageLog(
        localStorage.getItem("User"),
        localStorage.getItem("EmailId"),
        "ASTT",
        "File Attachments",
      );
      return true;
    }

    return false;
  };

  // Helper function to process attachment data
  const processAttachmentData = async (
    data,
    type,
    setAttachedFiles,
    setFilteredAttachedFiles,
    setSelectedFile,
    Snackhandler,
  ) => {
    if (!data) {
      Snackhandler(
        true,
        "Error occured while fetching Attachment Details.",
        "error",
      );
      return false;
    }

    const uniqueId = getUniqueId(type, data);

    if (!uniqueId) {
      return false;
    }

    return await handleFileAttachmentDetails(
      uniqueId,
      type,
      setAttachedFiles,
      setFilteredAttachedFiles,
      setSelectedFile,
      Snackhandler,
    );
  };

  // Helper function to handle file attachment type response
  const handleFileAttachmentType = async (
    fileAttachmentData,
    setFileAttachmentType,
    setSelectedAttachmentType,
    data,
    type,
    setAttachedFiles,
    setFilteredAttachedFiles,
    setSelectedFile,
    Snackhandler,
  ) => {
    if (!fileAttachmentData.status) {
      Snackhandler(
        true,
        "Error occured while fetching Attachment Type.",
        "error",
      );
      return false;
    }

    setFileAttachmentType(fileAttachmentData.data);
    setSelectedAttachmentType(0);

    return await processAttachmentData(
      data,
      type,
      setAttachedFiles,
      setFilteredAttachedFiles,
      setSelectedFile,
      Snackhandler,
    );
  };

  // Refactored main useEffect
  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoading(true);
      }

      try {
        const fileAttachmentData = await getFileAttachment(props.type);

        if (cancelled) return;

        await handleFileAttachmentType(
          fileAttachmentData,
          setFileAttachmentType,
          setSelectedAttachmentType,
          props.data,
          props.type,
          setAttachedFiles,
          setFilteredAttachedFiles,
          setSelectedFile,
          Snackhandler,
        );
      } catch (error) {
        if (!cancelled) {
          Snackhandler(true, `Error fetching data: ${error}`, "error");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [props.data, props.type]);

  const deleteFileAttachmentHandler = async (event, value) => {
    handleDialogOpen(
      async () => {
        try {
          setLoading(true);
          const deleteFile = await deleteFileAttachment(
            value.fileDocLibID,
            localStorage.getItem("User"),
          );
          if (deleteFile.status === true) {
            setAttachedFiles(
              attachedFiles.filter(
                (item) => item.fileDocLibID !== value.fileDocLibID,
              ),
            );
            setFilteredAttachedFiles(
              filteredAttachedFiles.filter(
                (item) => item.fileDocLibID !== value.fileDocLibID,
              ),
            );
            setLoading(false);
            Snackhandler(
              true,
              "Successfully deleted requested Roster Attachment.",
              "success",
            );
          } else {
            Snackhandler(
              true,
              "Errro occured: The file may have been deleted, please refresh to check.",
              "error",
            );
          }
        } catch (error) {
          Snackhandler(true, `Error while deleting file: ${error}`, "error");
        } finally {
          setLoading(false);
        }
      },
      "Delete Roster Attachment",
      "Are you sure you want to delete this Roster Attachment?",
      [],
      true,
    );
  };
  return (
    <>
      {loading && <BackdropComponent />}

      <Dialog
        open={dialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleDialogClose(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" sx={{ fontSize: "1.4rem" }}>
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            sx={{ fontSize: "1.2rem" }}
          >
            {dialogMessage}
            {dialogBulletList.length > 0 && (
              <>
                <Box sx={{ marginTop: "16px" }} />
                <ul>
                  {dialogBulletList.map((message, index) => (
                    <li key={`${message}-${index}`}>{message}</li>
                  ))}
                </ul>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ "& .MuiButtonRoot": { fontSize: "1.2rem" } }}>
          <Button onClick={() => handleDialogClose(false)} color="primary">
            {isConfirmationDialog ? "No" : "Cancel"}
          </Button>
          <Button
            onClick={() => handleDialogClose(true)}
            color="primary"
            autoFocus
          >
            {isConfirmationDialog ? "Yes" : "Proceed"}
          </Button>
        </DialogActions>
      </Dialog>

      <Grid
        container
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Box
              sx={{
                padding: "5px",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <UploadFileIcon className={classes.icons} />
                <Typography variant="h6" sx={{ fontWeight: 500 }}>
                  {props.type === "Classroster"
                    ? "Roster Attachments"
                    : t("ClassRequestAttachments")}
                </Typography>
              </Box>
              <CloseIcon
                onClick={(e) => {
                  props.onClose("right", false);
                }}
                className="cursor-pointer"
              />
            </Box>
          </Grid>
          <Grid item xs={12} padding={2}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Grid item xs={2}>
                <Typography>
                  <sup className="redColor">*</sup>
                  <b>
                    {props.type === "Classrequest"
                      ? t("AttachmentType")
                      : "Attachment Type"}
                  </b>
                </Typography>
              </Grid>
              <Grid item xs={4.25}>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    value={selectedAttachmentType}
                    onChange={(event) => setFileTypeHandler(event)}
                    sx={{ backgroundColor: "#ffffff" }}
                  >
                    <MenuItem key="0" value="0">
                      All
                    </MenuItem>
                    {fileAttachmentType.map((row) => (
                      <MenuItem
                        key={row.fileAttachmentTypeId}
                        value={row.fileAttachmentTypeId}
                      >
                        {row.fileAttachmentType}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={5.75}>
                {selectedAttachmentType === 6 && (
                  <Button
                    className={classes.clickHere}
                    onClick={handleDownload}
                  >
                    <b>Sample File</b>
                  </Button>
                )}
              </Grid>
            </Box>
          </Grid>
          <Grid item md={5.7} padding={1}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px",
                alignItems: "center",
              }}
            >
              <ThemeProvider theme={btnAttachFile}>
                <Button
                  variant="contained"
                  color="btnAttach"
                  component="label"
                  startIcon={<AttachFileIcon />}
                  disabled={
                    selectedAttachmentType === "0" ||
                    selectedAttachmentType === 0
                  }
                >
                  {t("AttachFile")}
                  <input
                    onChange={fileUploadHandler}
                    id="filePicker"
                    accept=".csv, .docx, .msg, .pdf, .txt, .xls, .xlsb, .xlsm, .xlsx, .zip"
                    type="file"
                    hidden
                    onClick={(event) => {
                      event.currentTarget.value = null;
                    }}
                    multiple={selectedAttachmentType !== 6}
                  />
                </Button>
              </ThemeProvider>
              <Button
                variant="contained"
                color="warning"
                component="label"
                startIcon={<CloudUploadIcon />}
                disabled={selectedFile.length === 0}
                onClick={handleUploadClick}
              >
                Upload File
              </Button>
              {fileAttachError && (
                <p className="redColor rdd">Please attach file</p>
              )}
              <Dialog open={openDailog} onClose={() => setOpenDailog(false)}>
                <DialogTitle> File Already Uploaded </DialogTitle>
                <DialogContent>
                  <p>Do you want to append the exsisting file or replace it?</p>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleAppend}>Append</Button>
                  <Button onClick={handleReplace} color="primary">
                    Replace
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </Grid>

          <Grid item xs={12} padding={1}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "10px",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
            >
              {selectedFile.length === 0 && selectedAttachmentType !== 0 && (
                <Box
                  key="no-attachment-message"
                  sx={{
                    borderRadius: 2.5,
                    backgroundColor: "#fff5e4",
                    border: "1px solid #ccc4b6",
                    padding: 1,
                    marginBottom: 0.5,
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Typography variant="h8">
                    <b>There is nothing attached</b>
                  </Typography>
                </Box>
              )}

              {selectedFile.length > 0 &&
                selectedFile.map((item, index) => (
                  <Box
                    key={`${index}-${item.name}`}
                    sx={{
                      borderRadius: 2.5,
                      backgroundColor: "#c9dcff",
                      border: "1px solid #a0b0cc",
                      padding: 1,
                      marginBottom: 0.5,
                      display: "flex",
                      justifyContent: "flex-end",
                      flexShrink: 0,
                    }}
                  >
                    <Typography variant="h8">
                      <b>{item.name}</b>
                    </Typography>
                    <CloseIcon
                      className="cursor-pointer"
                      onClick={(event) => removeSelectedFile(event, item)}
                      fontSize="small"
                    />
                  </Box>
                ))}
            </Box>
          </Grid>
          <Grid item xs={12} padding={2}>
            <Box>
              <Grid
                container
                alignItems="center"
                sx={{ paddingBottom: "1rem" }}
              >
                <Grid item xs={3.5} sx={{ fontWeight: "bold" }}>
                  File Name
                </Grid>
                <Grid item xs={2} sx={{ fontWeight: "bold" }}>
                  File Type
                </Grid>
                <Grid item xs={3} sx={{ fontWeight: "bold" }}>
                  Modified By
                </Grid>
                <Grid item xs={2.5} sx={{ fontWeight: "bold" }}>
                  Modified Date
                </Grid>
                <Grid
                  item
                  xs={1}
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  Delete
                </Grid>
              </Grid>

              {filteredAttachedFiles.length > 0 ? (
                filteredAttachedFiles.map((value, index) => (
                  <Grid
                    className={`${classes.attachedFile} rdd`}
                    key={`${index}-${value}`}
                    container
                    alignItems="center"
                    sx={{ "& .MuiGrid-item": { wordBreak: "break-word" } }}
                  >
                    <Grid item xs={3.5}>
                      <a
                        href={value.fileURLPath}
                        target="_blank"
                        download
                        rel="noreferrer"
                      >
                        {value.fileName}
                      </a>
                    </Grid>
                    <Grid item xs={2}>
                      {value.fileAttachmentType}
                    </Grid>
                    <Grid item xs={3}>
                      {value.modifiedBy}
                    </Grid>
                    <Grid item xs={2.75}>
                      {moment
                        .utc(value.modifiedDate)
                        .format("MM/DD/YYYY hh:mm A")}
                    </Grid>
                    <Grid item xs={0.75}>
                      {(value.fileAttachmentTypeId === 6 &&
                        value.totalUsage === 0) ||
                      value.fileAttachmentTypeId !== 6 ? (
                        <Tooltip title="Delete">
                          <IconButton
                            onClick={(event) => {
                              deleteFileAttachmentHandler(event, value);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="In-Use">
                          <IconButton sx={{ color: "#ff4c4c" }}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Grid>
                  </Grid>
                ))
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Typography variant="body1" color="error" fontWeight="bold">
                    No record(s) found
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

FileAttachmentDrawer.propTypes = {
  data: PropTypes.shape({
    classRequestId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    classRosterId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["Classrequest", "Classroster"]).isRequired,
};

export default FileAttachmentDrawer;
